import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-revoke-payroll',
  templateUrl: './revoke-payroll.component.html',
  styleUrls: ['./revoke-payroll.component.scss']
})
export class RevokePayrollComponent {

  public comment = '';

  constructor(
    public dialogRef: MatDialogRef<RevokePayrollComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { detachmentName: string; isApproved: boolean }
  ) {}

  public get canRevoke(): boolean {
    if (this.data.isApproved) return this.comment.trim().length > 0;
    return true;
  }

  public onRevoke(): void {
    if (!this.canRevoke) return;
    this.dialogRef.close({ confirmed: true, comment: this.comment.trim() });
  }
}
